export default "__VITE_ASSET__DA5dvi48__"